import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";


function VideoSection() {
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
            window.matchMedia("(min-width: 1280px)").matches
          );
           useEffect(() => {
              const mediaQuery = window.matchMedia("(min-width: 1280px)");
              const handleChange = (e) => setIsLargeScreen(e.matches);
              mediaQuery.addEventListener("change", handleChange);
          
              return () => {
                mediaQuery.removeEventListener("change", handleChange);
              };
            }, []);
  const videos = [
    {
      url: "https://youtu.be/ChfpVJGCkDo",
      title: "Cervical joint 3 axis ROM",
      description: "Cervical Rotation, Lateral Flexion, Extension & Flexion",
    },
    {
      url: "https://youtu.be/qwRHOmJ5sV4",
      title: "Ankle joint ROM",
      description:
        "Tarsal Joint: Inversion Eversion, Dorsiflexion, Plantarflexion",
    },
    {
      url: "https://youtu.be/l6OGky9qLKo",
      title: "Knee ROM Measurement",
      description: "Knee Flexion in 2 Positions",
    },
    {
      url: "https://youtu.be/tueI2glqVUs",
      title: "Ankle joint ROM",
      description: "Shoulder complex flection & Abduction",
    },
  ];

  return (
    <>
    {isLargeScreen&&
     <div className=" bg-gray-light m-0 p-0">
     <div className="bg-dark-blue text-white upy-3 m-0 ">
       <p className="text-center fw-bold ufs-7 m-0 p-0">Everything you need to know to use GoNeo effectively</p>
     </div>
     <div className="  d-flex flex-column bg-gray-light m-0 upx-10 ">
       {/* First row with two videos */}
       <div className="row  d-flex justify-content-evenly upx-5 upy-5 bg-gray-light">
         {videos.slice(0, 2).map((video, index) => (
           <div
             key={index}
             className="col-6 position-relative d-flex flex-column align-items-center box-shadow uh-120 uw-130 p-0 umx-5 br-5"
             style={{
               borderRadius: "calc(var(--unit) * 5) !important",
               overflow: "hidden",
             }}
           >
            <div className="p-0 m-0 uw-130 uh-80 br-5">
               <ReactPlayer
                 url={video.url}
                 controls
                 width="100%" // Set to 100% width
                 height="100%" 
                 backgroundSize="cover"
               />
               </div>
             <p className="text-center ufs-6 fw-bold text-blue upt-3 m-0">
               {video.title}
             </p>
             <p className="text-center ufs-5 fw-bold text-gray m-0 p-0">
               {video.description}
             </p>
           </div>
         ))}
       </div>

       {/* Second row with two videos */}
       <div className="row  d-flex justify-content-evenly bg-gray-light upy-5 ">
         {videos.slice(2, 4).map((video, index) => (
           <div
             key={index}
             className="col-6 position-relative d-flex flex-column align-items-center box-shadow uh-120 uw-130 umx-5 br-5"
             style={{
               borderRadius: "calc(var(--unit) * 5) !important",
               overflow: "hidden",
             }}
           >
             <div className="p-0 m-0 uw-130 uh-80">
               <ReactPlayer
                 url={video.url}
                 controls
                 width="100%" // Set to 100% width
                 height="100%" 
                 backgroundSize="cover"
               />
               </div>
             <p className="text-center ufs-6 fw-bold text-blue m-0 upt-3">
               {video.title}
             </p>
             <p className="text-center fw-bold ufs-5 text-gray m-0 p-0">
               {video.description}
             </p>
           </div>
         ))}
       </div>
     </div>
   </div>
    }{!isLargeScreen&&
      <div className="bg-gray-light m-0 p-0 w-100"
      style={{
        
        overflow: "hidden",
      }}>
  <div className="bg-dark-blue text-white  px-2 m-0">
    <p className="text-center fw-bold ufs-14 m-0 p-0">
      Everything you need to know to use GoNeo effectively
    </p>
  </div>

  <div className="d-flex flex-column m-0 p-4 align-items-center bg-gray-light ">
    {/* All videos stacked vertically */}
    {videos.slice(0, 4).map((video, index) => (
      <div
        key={index}
        className="position-relative d-flex flex-column align-items-center box-shadow w-100 uh-300 mb-5 p-0 br-20"
        style={{
          borderRadius: "calc(var(--unit) * 20)",
          overflow: "hidden",
        }}
      >
        <div className="p-0 m-0 w-100 uh-250">
          <ReactPlayer
            url={video.url}
            controls
            width="100%"
            height="100%"
            backgroundSize="cover"
            padding="0"
            margin="0"
          />
        </div>
        <p className="text-center ufs-14 fw-bold text-blue mb-0 mt-3">
          {video.title}
        </p>
        <p className="text-center ufs-12 fw-bold text-gray  mb-4 upx-5">
          {video.description}
        </p>
      </div>
    ))}
  </div>
</div>

    }
    
    </>
   
  );
}

export default VideoSection;
